// extracted by mini-css-extract-plugin
export default {"homeNav":"nav_homeNav__1uXma","scrolled":"nav_scrolled__IFG3Q","homeNavWrapper":"nav_homeNavWrapper__spu8h","navLink":"nav_navLink__Qoc4z","active":"nav_active__2YpeI"};